<template>
  <div class="echart-content">
    <div :id="echartId" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    unit: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      echartId: uuidv1(),
      name: "",
    };
  },
  created() {
    console.log(11111111);
    console.log(this.echartId);
    console.log(this.chartData);
    console.log(this.unit);
    this.name = this.unit;
    console.log(this.name);
  },
  mounted() {
    console.log(11111111);
    this.getData();
    // this.getEchart(obj);
  },
  methods: {
    getData() {
      let data = JSON.parse(JSON.stringify(this.chartData));

      let name = [];
      data.map((item) => {
        name.push(item.name);
      });
      console.log(name);
      this.getEchart(data, name);
    },
    getEchart(obj, name) {
      let this_ = this;
      let myChart = this.$echarts.init(document.getElementById(this.echartId));
      var option = {
        // title: {
        //   text: "同名数量统计",
        //   subtext: "纯属虚构",
        //   left: "center"
        // },
        tooltip: {
          trigger: "item",
          formatter:
            this_.name == undefined
              ? "{b} : {c} kWh ({d}%)"
              : `{b} : {c} ${this_.name} ({d}%)`,
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          data: name,
          // selected: data.selected
        },
        series: [
          {
            type: "pie",
            radius: "46%",
            data: obj,
            avoidLabelOverlap: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              // formatter: "{b}\n{c}kWh\n({d}%)",
              formatter: function(params) {
                let pieName = params.name.split("/").join(" ");
                let num = params.value;
                let percent = params.percent;
                if (this_.name != undefined) {
                  return (
                    pieName + "\n" + num + this_.unit + "\n" + percent + "%"
                  );
                } else {
                  return pieName + "\n" + num + "kWh" + "\n" + percent + "%";
                }
              },
              color: "#000",
              fontWeight: "bolder",
            },
          },
        ],
      };
      myChart.setOption(option, true);
      if (myChart) {
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.echart-content {
  width: 100%;
  height: 300px;
}
</style>
